<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title">
      <strong>
        {{ 'CUSTOMER_RECORD_OWNER_CHANGE' | translate }}
      </strong>
    </p>
    <button type="button" class="close" (click)="closeDialog(false)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-dialog-content [ngStyle]="{'overflow': 'visible'}" #matContent>
      <div class="row mr-0 ml-0 mt-1" *ngIf="data.allowUserChange && data.allowUserGroupChange">
        <label class="col-form-label col-md-4">{{ 'CUSTOMER_RECORD_SEARCH_USER' | translate }}</label>
        <div class="form-group col-md-8">
          <label class="switch switch-text switch-info mb-0">
            <input type="checkbox" class="switch-input"
                   [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="ownerChangeModel.changeUsers">
            <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
            <span class="switch-handle"></span>
          </label>
        </div>
      </div>
      <div class="row m-0" *ngIf="ownerChangeModel.changeUsers">
        <div class="col-md-4"></div>
        <!-- /.col-md-4 -->
        <div class="form-group col-md-8">
          <angular2-multiselect [data]="users" [settings]="remoteSearchDropdownSettings"
                                class="form-control"
                                [(ngModel)]="ownerChangeModel.ownerUsers"
                                (onRemoteSearch)="loadOwnerUsersForChange($event.target.value)"
                                #userChange="ngModel" name="userChange" id="userChange">
          </angular2-multiselect>
        </div>
        <!-- /.col-md-8 -->
      </div>
      <!-- /.row -->
      <div class="row m-0" *ngIf="data.allowUserChange && data.allowUserGroupChange">
        <label class="col-form-label col-md-4">{{ 'CUSTOMER_RECORD_SEARCH_USER_GROUP' | translate }}</label>
        <div class="form-group col-md-8">
          <label class="switch switch-text switch-info mb-0">
            <input type="checkbox" class="switch-input"
                   [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="ownerChangeModel.changeUserGroups">
            <span class="switch-label" data-on="&#xe957;" data-off="&#xe98e;"></span>
            <span class="switch-handle"></span>
          </label>
        </div>
      </div>
      <div class="row m-0" *ngIf="ownerChangeModel.changeUserGroups">
        <div class="col-md-4"></div>
        <!-- /.col-md-4 -->
        <div class="form-group col-md-8">
          <angular2-multiselect [data]="userGroups" [settings]="remoteSearchDropdownSettings"
                                class="form-control"
                                [(ngModel)]="ownerChangeModel.ownerUserGroups"
                                (onRemoteSearch)="loadOwnerUserGroupsForChange($event.target.value)"
                                #userGroupChange="ngModel" name="userGroupChange" id="userGroupChange">
          </angular2-multiselect>
        </div>
      </div>
      <!-- /.row -->
      <div class="row m-0">
        <label class="col-form-label col-md-4">{{ 'CUSTOMER_RECORD_OWNER_CHANGE' | translate }}</label>
        <div class="col-md-8">
          <mat-radio-group [required]="true" class="d-flex flex-column" [(ngModel)]="ownerChangeModel.changeType">
            <mat-radio-button [value]="'ADD'" [disableRipple]="true">{{
                'CUSTOMER_RECORD_OWNER_CHANGE_ADD' |
                  translate
              }}
            </mat-radio-button>
            <mat-radio-button [value]="'OVERRIDE'" [disableRipple]="true">{{
                'CUSTOMER_RECORD_OWNER_CHANGE_OVERRIDE' |
                  translate
              }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <!-- /.col-md-8 -->
      </div>
      <div class="alert alert-danger mt-1" *ngIf="ownerChangeModel.customerRecordIds.length > 1">
        <h6 class="alert-title">{{
            'CUSTOMER_RECORD_OWNER_MODIFICATION_MESSAGE' | translate: {
              count:
              ownerChangeModel.customerRecordIds.length
            }
          }}</h6>
      </div>
    </mat-dialog-content>
  </div><!-- /.modal-body -->
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary cursor-pointer" (click)="closeDialog(false)">
      {{
        'COMMON_BUTTON_CANCEL' |
          translate
      }}
    </button>
    <button type="button" class="btn btn-primary" (click)="changeOwners()">{{ 'COMMON_BUTTON_SAVE' | translate }}
    </button>
  </div>
</div>
